import { Reducer } from 'redux';

import { ApiUserAddress } from 'api/types';

import { BasicUser, UserType } from './currentUserType';
// import { tierStatusMap } from 'components/auth/kyc';

// Actions

export const changeUser = (
  loggedIn: boolean,
  userDetails?: BasicUser | undefined,
  extendedData?: {
    telephone?: string;
    countryCode?: string;
    address?: ApiUserAddress;
  }
) => ({
  type: 'CHANGE_USER' as const,
  loggedIn,
  userDetails,
  extendedData,
});

// export const updateUserTierStatus = (pendingKycStatus: string) => ({
//   type: 'UPDATE_USER_TIER_STATUS' as const,
//   pendingKycStatus,
// });

// export const debugUpdateUser = (user: Partial<UserDetailsType>) => ({
//   type: 'DEBUG_UPDATE_USER' as const,
//   user,
// });

type CurrentUserAction = ReturnType<typeof changeUser>;
// | ReturnType<typeof updateUserTierStatus>
// | ReturnType<typeof debugUpdateUser>;

// Reducer

const defaultState: UserType = {
  initialized: false,
  loggedIn: false,
  isCatchAllUser: false,
  email: '',
  id: 0,
  firstName: '',
  lastName: '',
  // Company account when /v1/user/info response includes a companyName field
  companyName: '',
  intercomId: '',
  intercomHash: '',
  magicCode: '',

  telephone: '',
  // kycTier: 0,
  // pendingKycStatus: tierStatusMap.NONE,
  countryCode: '',
};

export const currentUserReducer: Reducer<UserType, CurrentUserAction> = (
  state = defaultState,
  action
): UserType => {
  switch (action.type) {
    case 'CHANGE_USER': {
      if (!action.loggedIn) {
        // User not logged in
        return {
          ...defaultState,
          initialized: true,
        };
      }
      const newUser: UserType = {
        ...state,
        initialized: true,
        loggedIn: action.loggedIn,
        telephone: action.extendedData?.telephone || '',
        countryCode: action.extendedData?.countryCode || '',
        ...(action.userDetails || {}),
      };
      if (JSON.stringify(newUser) === JSON.stringify(state)) {
        return state;
      }
      return newUser;
    }
    // case 'UPDATE_USER_TIER_STATUS':
    //   return {
    //     ...state,
    //     pendingKycStatus: action.pendingKycStatus,
    //   };

    // case 'DEBUG_UPDATE_USER':
    //   return {
    //     ...state,
    //     ...action.user,
    //   };
    default:
      return state;
  }
};
